
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Calque_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 20.8 13.3","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"noun_Eye_3809642","transform":"translate(-1.975 -7)"}},[_c('g',{attrs:{"id":"Groupe_1386","transform":"translate(1.975 7)"}},[_c('path',{staticClass:"st0",attrs:{"id":"Tracé_6755","d":"M10.4 13.3C4.8 13.3.3 7.3.2 7.1c-.2-.3-.2-.6 0-.9C.3 6 4.8 0 10.4 0s10.1 6 10.2 6.2c.2.3.2.6 0 .9-.1.2-4.6 6.2-10.2 6.2zM1.7 6.7c1.1 1.3 4.6 5.2 8.7 5.2S18 8 19.1 6.7c-1.1-1.3-4.6-5.2-8.7-5.2S2.8 5.3 1.7 6.7z"}})]),_c('g',{attrs:{"id":"Groupe_1387","transform":"translate(8.664 9.965)"}},[_c('path',{staticClass:"st0",attrs:{"id":"Tracé_6756","d":"M3.7 7.4C1.7 7.4 0 5.8 0 3.7S1.7 0 3.7 0s3.7 1.7 3.7 3.7-1.6 3.7-3.7 3.7c.1 0 0 0 0 0zm0-5.9c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2c1.2 0 2.2-1 2.2-2.2C6 2.5 5 1.5 3.7 1.5c.1 0 0 0 0 0z"}})])])])
          )
        }
      }
    